'use client';

import { c as _c } from "react/compiler-runtime";
import { Button } from '@/app/components/button';
import { IconClose } from '@/app/components/icons/ui-actions/icon-close';
import { AppImage } from '@/app/components/media/app-image';
import { Link } from '@/app/components/navigation/link';
import { cn } from '@/app/utils/cn';
import { createDataAttributes } from '@/app/utils/createDataAttributes';
import { createDataGA } from '@/app/utils/createDataGA';
import { safeCall } from '@/app/utils/safeCall';
import { useStickyMenuDrag } from '@/app/utils/useStickyMenuDrag';
const REGISTER_LUCKY_DRAW_EVENT = 'register-lucky-draw';
const STICKY_MENU_SOURCE = 'https://assets.isuzu-tis.com/floaing_campaign_2027_e46c8d5b5a.webp';
export interface StickyMenuProps {
  className?: string;
  onClose?: () => void;
}
export const LuckyDrawStickyMenuButton = t0 => {
  const $ = _c(19);
  const {
    className,
    onClose
  } = t0;
  const {
    isDragging,
    toggleRef
  } = useStickyMenuDrag();
  let t1;
  if ($[0] !== onClose) {
    t1 = () => {
      safeCall(onClose);
    };
    $[0] = onClose;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const handleOnClose = t1;
  const t2 = !isDragging;
  let t3;
  if ($[2] !== className || $[3] !== isDragging || $[4] !== t2) {
    t3 = cn("ease-bezier pointer-events-auto flex flex-col items-end", {
      "transition-none": isDragging,
      "transition-transform duration-300 ease-out": t2
    }, className);
    $[2] = className;
    $[3] = isDragging;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = createDataAttributes({
      test: "sticky-menu-wrapper"
    });
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <IconClose />;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  let t7;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = createDataAttributes({
      test: "close-button"
    });
    t7 = createDataGA({
      eventName: REGISTER_LUCKY_DRAW_EVENT,
      click: true,
      group: "sticky-menu",
      text: "Close"
    });
    $[8] = t6;
    $[9] = t7;
  } else {
    t6 = $[8];
    t7 = $[9];
  }
  let t8;
  if ($[10] !== handleOnClose) {
    t8 = <Button className="rounded-full" size="2xs" color="black" aria-label="Close" iconBefore={t5} onClick={handleOnClose} {...t6} {...t7} />;
    $[10] = handleOnClose;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t10;
  let t9;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = createDataAttributes({
      test: "sticky-menu"
    });
    t10 = createDataGA({
      eventName: REGISTER_LUCKY_DRAW_EVENT,
      click: true,
      group: "sticky-menu",
      text: "Go to register"
    });
    $[12] = t10;
    $[13] = t9;
  } else {
    t10 = $[12];
    t9 = $[13];
  }
  let t11;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <Link className="size-24 lg:size-30" href="/register" {...t9} {...t10}><AppImage src={STICKY_MENU_SOURCE} width={120} height={120} sizes="(min-width: 1024px) 120px, 96px" params={{
        f: "webp"
      }} preloadOffset="0px -24px 0px 0px" alt="Go to register" draggable={false} objectFit="contain" className="size-full" /></Link>;
    $[14] = t11;
  } else {
    t11 = $[14];
  }
  let t12;
  if ($[15] !== t3 || $[16] !== t8 || $[17] !== toggleRef) {
    t12 = <div ref={toggleRef} data-myi-hide={true} className={t3} {...t4}>{t8}{t11}</div>;
    $[15] = t3;
    $[16] = t8;
    $[17] = toggleRef;
    $[18] = t12;
  } else {
    t12 = $[18];
  }
  return t12;
};